<template>
    <div
        class="bg-tertiary-container text-on-tertiary-container rounded-medium mb-4 flex flex-row items-center gap-4 p-4">
        <BaseIcon>hourglass</BaseIcon>
        <div class="flex flex-col">
            <p class="text-title-medium">
                {{ $t('coaching.status.pending.title') }}
            </p>
            <p class="text-body-medium">
                {{ $t('coaching.status.pending.description') }}
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
</script>
